import { jsx as _jsx } from "react/jsx-runtime";
export const EmailTag = ({ children }) => {
    return (_jsx("div", { className: "bg-[#F3F3F6] py-1 px-2 rounded text-sm font-normal leading-5", children: children }));
};
//# sourceMappingURL=EmailTag.js.map